import React from "react";

const TrafficSourcesListView = React.lazy(
  () => import("./TrafficSourcesList.view")
);

const TrafficSourcesListLoadable = () => <TrafficSourcesListView />;

export default () => <TrafficSourcesListLoadable />;
